/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { GetCurrentConsumer as getConsumer } from '../redux/api/user.js'

import { useLocation } from 'react-router-dom'
import { GetTenantVersion } from '../redux/api/About.js'
import { injectClarityBasedOnResponse } from '../utils/clarityScripts.js'

const ConsumerContext = createContext({})
const ConsumerProvider = ({ children }) => {
    const dispatch = useDispatch()
    const [userData, setUserData] = React.useState({})
    const [tenant, setTenant] = useState('')
    const location = useLocation()
    const [loading, setLoading] = useState(true)

    const getTenant = async () => {
        try {
            const response = await GetTenantVersion()

            if (response?.status === 200 && response?.data) {
                setTenant(response?.data)
                injectClarityBasedOnResponse(response?.data)
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    async function GetCurrentConsumer(type) {
        try {
            if (
                location?.pathname &&
                location?.pathname !== '/register' &&
                location?.pathname !== '/auth/login' &&
                location?.pathname !== '/ConfirmRegistration' &&
                location?.pathname !== '/authenticateAccess'
            ) {
                const storageConsumer = JSON.parse(localStorage.getItem('user'))
                setUserData(storageConsumer)

                const response = await getConsumer()
                if (response) {
                    localStorage.setItem('showNegotiations', response?.hasNegotiation)
                    localStorage.setItem('user', JSON.stringify(response))
                    setUserData(response)
                    return response
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (
            location?.pathname &&
            location?.pathname !== '/register' &&
            location?.pathname !== '/auth/login' &&
            location?.pathname !== '/ConfirmRegistration' &&
            location?.pathname !== '/authenticateAccess' &&
            location?.pathname !== '/confirmRegistration'
        ) {
            const intervalId = setInterval(() => {
                GetCurrentConsumer()
            }, 480000)
            return () => clearInterval(intervalId)
        }
    }, [dispatch])

    useEffect(() => {
        getTenant()
    }, [])

    return (
        <ConsumerContext.Provider
            value={{
                GetCurrentConsumer,
                userData,
                tenant,
                loading,
                setUserData,
                setLoading,
            }}
        >
            {children}
        </ConsumerContext.Provider>
    )
}

function useConsumer() {
    const context = useContext(ConsumerContext)
    return context
}

export { ConsumerProvider, useConsumer }
